import * as Yup from 'yup'
import {
  arrayPreferenceSchema,
  preferenceSchema,
} from '../BeautyPreferencesForm/config'

export const validationSchema = Yup.object().shape({
  pants_size_w: preferenceSchema.required("Women's Pants Size is required"),
  pants_size_m: preferenceSchema.required("Men's Pants Size is required"),
  tops_size: preferenceSchema.required('Tops Size is required'),
  suits_size: preferenceSchema.required('Suits Size is required'),
  shoe_size_new: preferenceSchema.required('Shoe Size is required'),
  dress_size: preferenceSchema.required('Dress Size is required'),
  shapewear_size: preferenceSchema.required('Shapewear Size is required'),
  bra_band_size: preferenceSchema.required('Bra Band Size is required'),
  bra_cup_size: preferenceSchema.required('Bra Cup Size is required'),
  foot_width: preferenceSchema.required('Foot Width is required'),
  body_type: arrayPreferenceSchema.required('Body Type is required'),
  height: preferenceSchema.required('Height is required'),
  weight: preferenceSchema.required('Weight is required'),
  pants_type: preferenceSchema.required('Pants Type is required'),
  ear_piercings: preferenceSchema.required('Ear Piercings status is required'),
})
